import styles from './PaymentSuccessModal.module.scss';

export default function PaymentSuccessModal({
    open,
    packageName,
    onClose,
}) {
    if (!open) return null;

    return (
        <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="payment-success-title">
            <div className={styles.modal}>
                <div className={styles.badge}>Payment Confirmed</div>
                <div className={styles.iconWrap}>
                    <div className={styles.iconOrb}>✓</div>
                </div>
                <h2 id="payment-success-title" className={styles.title}>
                    Your payment was successful.
                </h2>
                <p className={styles.description}>
                    {packageName
                        ? `${packageName} is now active on your account.`
                        : 'Your selected plan is now active on your account.'}
                    {' '}Your billing details have been updated, and you can review everything from your settings page.
                </p>
                <div className={styles.highlightCard}>
                    <div className={styles.highlightLabel}>What happened next</div>
                    <div className={styles.highlightValue}>Access unlocked and billing synced</div>
                </div>
                <div className={styles.actions}>
                    <button
                        type="button"
                        className={styles.primaryButton}
                        onClick={onClose}
                    >
                        Review My Settings
                    </button>
                    <button
                        type="button"
                        className={styles.secondaryButton}
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}